import { authRoles } from "../../../auth/authRoles";
import EditEMagazine from "./EditEMagazine";
import EMagazine from "./EMagazine";
import TambahEMagazine from "./TambahEMagazine";

const eMagazineRoute = [
  {
    path: "/e-magazine/edit/:id",
    exact: true,
    component: EditEMagazine,
    auth: authRoles.all,
  },
  {
    path: "/e-magazine/tambah",
    exact: true,
    component: TambahEMagazine,
    auth: authRoles.all,
  },
  {
    path: "/e-magazine",
    exact: true,
    component: EMagazine,
    auth: authRoles.all,
  },
];

export default eMagazineRoute;
